<template>
  <div v-if="theVisible" class="kst-errors-helper">
    <div class="help is-danger">
      <div class="content kst-list">
        <ul>
          <li 
            v-for="(message, index) of theItems"
            :key="index"
            class="has-text-left"
            v-html="message"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import AppCatalog from "../../../services/App/AppCatalog.js";

export default {
  props: {
    items: [Array, String]
  },
  data: () => ({
    AppCatalog: AppCatalog
  }),
  computed: {
    theItems() {
      return Array.isArray(this.items) ? this.items : [this.items];
    },
    theVisible() {
      return this.getVisible();
    }
  },
  methods: {
    getVisible() {
      if (this.items === undefined || this.items === null) {
        return false;
      }
      else if (Array.isArray(this.items)) {
        if (this.items.length === 0) {
          return false;
        }
      }

      return true;
    }
  }
}
</script>